import type { BodyRouteParamsRequest } from '@pba/react-utils';
import { type ApiClientResponse, apiClient, routes } from 'common/services';
import type { KudoContentObjectDetailDataObject } from 'models/service';

type UpdateKudoRequest = { kudo: Record<string, unknown> };

export const updateKudo = async ({
  body,
  routeParams: { id },
}: BodyRouteParamsRequest<UpdateKudoRequest, { id: string }>) =>
  apiClient.patch<KudoContentObjectDetailDataObject, ApiClientResponse<KudoContentObjectDetailDataObject>>(
    routes.kudos.update(id),
    body,
  );
